import { Dayjs } from "dayjs";
import { getFilledArrayOrDefault } from "../../../../utils";
import { DATE_URL_FORMAT } from "./useRipeningRoom";

// TODO: I foresee a future where we use number of boxes instead of pallet count..
export enum RipeningDenominator {
    all_pallets = "all_pallets",
    checked_pallets = "checked_pallets",
}


export function getRipeningClasses({
    pallets,
    ripeningField,
    date,
    denominator = RipeningDenominator.checked_pallets,
}: {
    pallets: any[];
    ripeningField: any;
    date: Dayjs;
    denominator?: RipeningDenominator;
}) {
    const categoryName = ripeningField?.category_name || "ripening_class";
    const lookupKey = `dominant_${categoryName}_${date.format(DATE_URL_FORMAT)}`;
    const ripeningClassesArray = getFilledArrayOrDefault(ripeningField?.categories);
    const allPalletsTotal = pallets?.length || 0;

    const baseClasses = [
        ...ripeningClassesArray,
        { value: "mixed", label: "Mixed", color: "orange" },
        { value: "checked", label: "Checked", color: "#555", className: "pt-3", hide_bar: true },
    ];

    let total = allPalletsTotal;
    let classCounts: Record<string, number> = {};


    // Initialize all counts to 0 including "checked"
    classCounts = baseClasses.reduce((acc, item) => ({ ...acc, [item.value]: 0 }), {});

    classCounts = getFilledArrayOrDefault(pallets).reduce((acc, pallet) => {
        const dominantClass = pallet[lookupKey];

        if (!dominantClass || dominantClass === "not_checked") {
            // *If there is no class actually measured, then we can see if there is a target ripening class for this date
            // *assuming the ripener knows what he is doing and the fruit is actually ripened to this class on this date
            if (pallet[`target_${categoryName}`] && pallet?.target_release_date === date.format(DATE_URL_FORMAT)) {
                const targetClass = pallet[`target_${categoryName}`];
                acc[targetClass] = (acc[targetClass] || 0) + 1;

                // acc.checked += 1; // ! Target class does not count as checked
                return acc;
            }
            return acc; // skip unclassified
        }

        const value = ripeningClassesArray.find((item) => String(item.value) === String(dominantClass)
        || String(item?.label).toLowerCase() === String(dominantClass).toLowerCase())?.value || dominantClass;

        acc[value] = (acc[value] || 0) + 1;
        acc.checked += 1;

        return acc;
    }, classCounts);


    total = denominator === RipeningDenominator.checked_pallets
        ? classCounts.checked
        : allPalletsTotal;


    let cumulative = 0;
    const classes = baseClasses.map((item) => {
        const count = classCounts[item.value] || 0;
        cumulative += count;
        return {
            ...item,
            count,
            cumulative,
        };
    });

    return { classes, total, checked: classCounts.checked };
}
